import { TURNO_PRESETS } from '../../pages/admin/turnos-shared';

type Props = {
  onSelect: (key: string) => void;
};

export function TurnosPresetPicker({ onSelect }: Props) {
  return (
    <div className="ac-turno-preset">
      <p className="ac-turno-preset__intro">
        Escolha um modelo base para o turno. Todos os horários e o template de aulas podem ser ajustados depois.
      </p>
      <div className="ac-turno-preset__grid">
        {Object.entries(TURNO_PRESETS).map(([key, preset]) => (
          <button
            key={key}
            type="button"
            data-lab-preset={key}
            className="ac-turno-preset__card"
            style={{ '--preset-cor': preset.cor } as React.CSSProperties}
            onClick={() => onSelect(key)}
          >
            <span className="ac-turno-preset__icon" aria-hidden>
              {preset.icon}
            </span>
            <span className="ac-turno-preset__nome">{preset.form.nome}</span>
            <span className="ac-turno-preset__desc">{preset.desc}</span>
            <span className="ac-turno-preset__range">
              {preset.form.horaEntradaOficial} — {preset.form.horaSaidaOficial}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
